import type { ReactNode } from 'react';

import { Button, Flex, Text } from '@spotify-internal/encore-web';

import styles from './IntroStep.module.css';

type IntroStepProps = {
  title: ReactNode;
  description?: ReactNode;
  buttonLabel?: string;
  onNext?: () => void;
  img: string;
  disabled?: boolean;
};

export const IntroStep = ({
  title,
  description,
  buttonLabel = 'Continue',
  onNext,
  img,
  disabled,
}: IntroStepProps) => (
  <div className={styles.root}>
    <Flex className={styles.layout} justifyContent="center">
      <Flex
        className={styles.content}
        direction="column"
        gap="looser-3"
        alignItems="center"
      >
        <img className={styles.image} src={img} alt="" width="350" />
        <div>
          <Text as="h1" variant="titleMedium" className={styles.title}>
            {title}
          </Text>
          {description && (
            <Text as="div" variant="bodyMedium">
              {description}
            </Text>
          )}
        </div>
        {onNext && (
          <Button
            variant="primary"
            size="medium"
            data-testid="continue"
            onClick={onNext}
            disabled={disabled}
          >
            {buttonLabel}
          </Button>
        )}
      </Flex>
    </Flex>
  </div>
);
